import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  access_token: null,
  refresh_token: null,
  role: null,
  isLoggedIn: false,
  permissions: [], 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {

    loginSuccess: (state, action) => {
      state.user = action.payload.user;
      state.access_token = action.payload.access_token;
      state.refresh_token = action.payload.refresh_token;
      state.role = action.payload.role;
      state.isLoggedIn = true;
      state.permissions = action.payload.permissions || [];
    },

    logout: (state) => {
      state.user = null;
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      state.isLoggedIn = false;
      state.permissions = [];
    },

    updatePermission: (state, action) => {
      state.permissions = action.payload;
    },

    updateUser: (state, action) => {
      state.user = action.payload;
    }
  },
});

export const { loginSuccess, logout, updateUser, updatePermission } = authSlice.actions;

export default authSlice.reducer;